import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');

const websiteBuilderRoutes: RouteRecordRaw[] = [{
    path: '/website-builder',
    component: BaseDashboard,
    meta: {
        title: 'Website builder',
        icon: 'mdi-view-dashboard-edit-outline',
        noCache: false,
        hidden: true,
        permissions: ['settings_view'],
        middleware: ['auth'],
        layout: 'Dashboard',
    } as CommonRouteMeta,
    children: [
        {
            path: '',
            components: {
                default: () => import('@/views/websiteBuilder/WebsiteBuilder.vue'),
            },
            name: 'website-builder.index',
            meta: {title: 'Website builder', icon: 'mdi-view-dashboard-edit-outline', noCache: false, isBase: true},
        },
    ],
}];

export default websiteBuilderRoutes;
